<div class="mb-5 iframe-container" *ngIf="(iFrameLink$ | async)?.url as url">
  <iframe
    class="modal-iframe"
    title="{{iFrameTitle}}"
    [src]="url | safeResourceUrl"
  >
  </iframe>
</div>
